<template>
  <div class="number-input">
    <input
      :name="name"
      required=true
      @change="updateNum"
      ref="numberInput"
      :value="value"
      :aria-label="name"
      type="number"
      min="0"
      :max="max"
      :min="min"
      :key="`number-option-${name}`"
      v-bind="$attrs"
    />
    <div class="number-input__button-container">
      <button type="button" @click="increment" class="num-up">
        <InlineSvg src="images/icons/UI_Button_Dropdown-Arrow-Navy.svg"></InlineSvg>
      </button>
      <button type="button" @click="decrement" class="num-down">
        <InlineSvg src="images/icons/UI_Button_Dropdown-Arrow-Navy.svg"></InlineSvg>
      </button>
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
export default {
  components: {
    InlineSvg
  },
  props: {
    name: String,
    value: {
      type: String,
      default: '0'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    }
  },
  methods: {
    updateNum() {
      let v = parseInt(this.$refs.numberInput.value)
      if (isNaN(v)) {
        v = 0
      }
      if (v > this.max) {
        const s = this.max.toString()
        this.$refs.numberInput.value = s
        this.$emit('input', s)
      } else if (v < this.min) {
        const s = this.min.toString()
        this.$refs.numberInput.value = s
        this.$emit('input', s)
      } else {
        this.$emit('input', v.toString())
      }
    },
    increment() {
      let v = parseInt(this.$refs.numberInput.value)
      if (isNaN(v)) {
        v = 0
      }
      if (v < this.max) {
        const n = v + 1
        const s = n.toString()
        this.$refs.numberInput.value = s
        this.$emit('input', s)
      }
    },
    decrement() {
      let v = parseInt(this.$refs.numberInput.value)
      if (isNaN(v)) {
        v = 0
      }
      if (v > this.min) {
        const n = v - 1
        const s = n.toString()
        this.$refs.numberInput.value = s
        this.$emit('input', s)
      }
    }
  }
}
</script>

<style>
  .number-input {
    position: relative;

    input {
      width: 100%;
    }

    ::-webkit-input-placeholder { /* Edge */
      color: $blueWhale;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $blueWhale;
    }

    ::placeholder {
      color: $blueWhale;
    }

    &__button-container {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      height: 100%;
    }

    .num-up,
    .num-down {
      cursor: pointer;
      width: 8px;
      height: auto;
      svg {
        width: 100%;
        height: 100%;
      }
    }

    .num-up {
      margin-bottom: 3px;
      svg {
        transform: scaleY(-1);
      }
    }


  }
</style>
